import * as React from 'react';
import EfModal from '@/components/UI/Modal';
import Button from '@/components/UI/Button';
import Coupon from '../../Coupon2';
import BuyForm from '../BuyForm';
import { CouponRule, TranslationFn, RULE_TYPES } from '../types';
import { SHOW_AMOUNT_RULE_TYPES } from '../constants';
import styles from './RedeemConfirmModal.module.scss';

interface RedeemConfirmModalProps {
    rule: CouponRule | null;
    loading: boolean;
    t: TranslationFn;
    onConfirm: () => void;
    onClose: () => void;
    buyFormRef: React.RefObject<any>;
    customColor?: Record<string, string | undefined>;
    customStyle?: Record<string, string>;
}

/**
 * RedeemConfirmModal - Modal for confirming redemption
 */
const RedeemConfirmModal: React.FC<RedeemConfirmModalProps> = ({ rule, loading, t, onConfirm, onClose, buyFormRef, customColor, customStyle }) => {
    const hideAmount = !SHOW_AMOUNT_RULE_TYPES.includes(rule?.ruleType as any);
    const isPhysicalProduct = rule?.ruleType === RULE_TYPES.FREE_PRODUCTS;

    return (
        <EfModal className={`${styles.RedeemConfirmModal} coupon over-height`} width={1000} open={!!rule} visible={!!rule} onCancel={onClose} zIndex={1200}>
            <div className="content">
                <div className="content-left">
                    <Coupon
                        className="coupon-card"
                        coupon={rule}
                        hideAmount={hideAmount}
                        hideBtn
                        hideNote
                        customColor={customColor}
                        customStyle={customStyle}
                        modal={true}
                    />
                </div>
                <div className="content-right">
                    <div className="confirm-rule-content">
                        <h5 className="confirm-rule-title">{t('rules')}</h5>
                        <ul className="confirm-rule-list">
                            {rule?.noteList?.map((note: string, index: number) => (
                                <li key={index} className="confirm-rule-item">
                                    {note}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="line"></div>

                    {/* BuyForm for physical products */}
                    {isPhysicalProduct && <BuyForm ref={buyFormRef} />}

                    <h5 className="m-prompt-title">{t('confirm_text')}</h5>
                    <Button loading={loading} onClick={onConfirm} className="m-btn">
                        {t('confirm_btn')}
                    </Button>
                </div>
            </div>
        </EfModal>
    );
};

export default RedeemConfirmModal;
